import {isNil, isNotNil} from 'ramda';

import {Nullish} from 'shared/web';

/**
 * Tells whether a scalar field carries an override. An absent template value cannot be matched, so
 * any value the body holds counts as an override.
 */
export function isScalarOverride<T>(value: T | Nullish, templateValue: T | Nullish) {
  return isNotNil(value) && (isNil(templateValue) || value !== templateValue);
}
